<div id="labels" class="tab-pane fade active in">
    <!-- <div style="width:35%;float:left;">
        <h3 class="heading4">Log Detail</h3>
        <br>
   </div> -->

    <div style="width:100%;float:right;min-height:600px;padding-left:30px;">
        <br>
        <br>
        <table class="table table-bordered table-hover">
            <thead>
                <colgroup><col width="25%">
                <col width="25%">
                <col width="25%">
                <col width="25%"></colgroup>
            </thead>
                
            <tbody><tr style="background-color:#F9f9f9;">
                    <th>
                        <div class="center"><b>UserName</b></div >
                    </th>
                    <th><div class="center"><b>Date</b></div ></th>
                    <!-- <th>
                        <div class="center"><b>IpAddress</b></div >
                    </th> -->

                    <th>
                        <div class="center"><b>EventType</b></div >
                    </th>
                    <th>
                            <div class="center"><b>Description</b></div >
                    </th>

                </tr>
            
            </tbody>
            
            <tbody style="text-align:center;">
                    <tr *ngFor="let log of loglist">
                        <td>{{log.UserName}}</td>

                        <td style="width: 12%;">
                                {{log.TimeStamp | date:'MM-dd-yyyy HH:mm' }}
                        </td>
                        <td style="width: 12%;">
                                {{log.EventType}}
                        </td>

                        <td>
                                {{log.Description}}
                            
                        </td>
                        
                    </tr>
                    

            </tbody>
        </table>
    </div>
</div>